export default "__VITE_ASSET__82562f85__"